import { Validator } from 'vee-validate'

const customRules = [
  {
    name: 'fakeLength',
    validation: {
      /**
       *
       * @param field
       * @param params
       * @param data
       * @return {*}
       */
      getMessage(field, params, data) {
        return data && data.message
      },
      /**
       *
       * @param value
       * @param min
       * @param fakeMin
       * @param field
       * @return {Promise<unknown>}
       */
      validate(value, { min, fakeMin, field }) {
        return new Promise((resolve) => {
          resolve({
            valid: value.length ? Number(min) <= value.length : true,
            data:
              value.length && Number(min) <= value.length
                ? undefined
                : {
                    message: `The ${field} field must be at least ${fakeMin} characters.`,
                  },
          })
        })
      },
    },
    paramNames: ['min', 'fakeMin', 'field'],
  },
  {
    name: 'floatNumber',
    validation: {
      /**
       *
       * @param field
       * @param params
       * @param data
       * @return {*}
       */
      getMessage(field, params, data) {
        return data && data.message
      },
      /**
       *
       * @param value
       * @param digit
       * @param decimal
       * @param field
       * @return {Promise<unknown>}
       */
      validate(value, { digit, decimal, field }) {
        return new Promise((resolve) => {
          let rule = `^\\d{0,${digit - decimal}}`
          rule = String(value).includes('.') ? `${rule}\\.\\d{1,${decimal}}` : rule
          rule += '$'
          let reg = new RegExp(
            rule,
          ) /* "digit" or "digit.decimal" test - depends if there is a "." or not in the value */
          const valid = reg.test(value)
          resolve({
            valid,
            data: {
              message: `The ${field} field cannot contain more than ${
                digit - decimal
              } integral and ${decimal} decimal characters.`,
            },
          })
        })
      },
    },
    paramNames: ['digit', 'decimal', 'field'],
  },
]

export function extendValidator() {
  customRules.forEach((rule) => {
    Validator.extend(rule.name, rule.validation, rule.paramNames)
  })
}
